var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInsertShippingLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#3B66B0;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M3.1,21.7c-0.6,0-1.2-0.2-1.6-0.7c-0.5-0.5-0.7-1-0.7-1.6V5.1c0-0.3,0-0.5,0.1-0.8s0.2-0.5,0.4-0.7l1.4-1.8 C3,1.6,3.2,1.4,3.6,1.2S4.2,1,4.5,1h13.2c0.3,0,0.7,0.1,1,0.2s0.6,0.4,0.8,0.6L21,3.6c0.2,0.2,0.3,0.4,0.4,0.7 c0.1,0.2,0.1,0.5,0.1,0.8v5.6c-0.4-0.1-0.7-0.2-1.1-0.3c-0.4-0.1-0.8-0.1-1.2-0.1c-0.6,0-1.2,0.1-1.8,0.2c-0.6,0.1-1.1,0.4-1.6,0.7 V6.8H6.6V16l4.6-2.3l1.7,0.8c-0.2,0.4-0.3,0.8-0.4,1.3c-0.1,0.4-0.1,0.9-0.1,1.3c0,0.9,0.2,1.7,0.5,2.5c0.3,0.8,0.7,1.5,1.3,2.1H3.1 z M18.1,21.7v-3.5h-3.5V16h3.5v-3.5h2.3V16h3.5v2.3h-3.5v3.5H18.1z M3.6,4.5h15.2l-1-1.2H4.5L3.6,4.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsertShippingLine);
export default __webpack_public_path__ + "static/media/insert-shipping-line.72653b9c8c4cdc71f04784499174ec60.svg";
export { ForwardRef as ReactComponent };